
define(
	'Code25.CaterpartsGlobal.App'
	, [
		"Handlebars", "Utils", "Code25.CaterpartsGlobal.App.View"
	]
	, function (
		Handlebars, Utils, Code25CaterpartsGlobalAppView
	) {
		'use strict';

		return {
			mount: function mount(container) {

				var layout = container.getComponent('Layout');
				layout.registerView('AppDownload', function () {
					return new Code25CaterpartsGlobalAppView({ application: container });
				});

			}
		};

	});
